import React, { useState } from 'react'

import InternShipsBlock from './inrernShipsBlock/InternShipsBlock'
import EducationBlock from './educationBlock/EducationBlock'

import styles from './styles.module.scss'
import smoothscroll from 'smoothscroll-polyfill'

const PopupForInternShips = ({ setActivePopUp, checkDomenNameState, retake, setRetake, captchaSiteKey }) => {
  smoothscroll.polyfill()
  const [activeBlock, setActiveBlock] = useState('education')
  const [activeForm, setActiveForm] = useState(false)

  const checkActiveForm = () => {
    if (activeForm) {
      setRetake(true)
    } else {
      setActivePopUp(false)
    }
  }

  return (
    <div className={styles.wrapper_total_down}>
      <div className={styles.wrapper_total_left} onClick={checkActiveForm}></div>
      <div className={styles.wrapper_total_right}>
        {/*{!activeBlock && (*/}
        {/*  <div>*/}
        {/*    <p onClick={() => setActivePopUp(false)} className={styles.wrapper_total_right_p1}>*/}
        {/*      <span>&larr;</span>Вернуться назад*/}
        {/*    </p>*/}
        {/*    <p className={styles.wrapper_total_text_p2}>Выбери, что тебе подходит</p>*/}
        {/*    <div className={styles.wrapper_total_text}>*/}
        {/*      <div className={styles.wrapper_total_text_item}>*/}
        {/*        <div>*/}
        {/*          <p className={styles.wrapper_total_text_item_p1}>Программы стажировки</p>*/}
        {/*          <p className={styles.wrapper_total_text_item_p2}>*/}
        {/*            Сезонные программы с реальными задачами для студентов профильных направлений*/}
        {/*          </p>*/}
        {/*        </div>*/}
        {/*        <button onClick={() => setActiveBlock('internShips')}>*/}
        {/*          Выбрать стажировку <span>&rarr;</span>*/}
        {/*        </button>*/}
        {/*      </div>*/}

        {/*      <div className={styles.wrapper_total_text_item}>*/}
        {/*        <div>*/}
        {/*          <p className={styles.wrapper_total_text_item_p1}>Образовательные программы</p>*/}
        {/*          <p className={styles.wrapper_total_text_item_p2}>*/}
        {/*            Совместные магистерские программы с ведущими вузами в области биотехнологии*/}
        {/*          </p>*/}
        {/*        </div>*/}
        {/*        <button onClick={() => setActiveBlock('education')}>*/}
        {/*          Выбрать программу <span>&rarr;</span>*/}
        {/*        </button>*/}
        {/*      </div>*/}
        {/*    </div>*/}
        {/*  </div>*/}
        {/*)}*/}
        {/*{activeBlock === 'internShips' && (*/}
        {/*  <InternShipsBlock*/}
        {/*    setActivePopUp={setActivePopUp}*/}
        {/*    setActiveBlock={setActiveBlock}*/}
        {/*    checkDomenNameState={checkDomenNameState}*/}
        {/*    retake={retake}*/}
        {/*    setRetake={setRetake}*/}
        {/*    setActiveForm={setActiveForm}*/}
        {/*    activeForm={activeForm}*/}
        {/*  />*/}
        {/*)}*/}
        {activeBlock === 'education' && (
          <EducationBlock
            setActiveBlock={setActiveBlock}
            setActivePopUp={setActivePopUp}
            checkDomenNameState={checkDomenNameState}
            retake={retake}
            setRetake={setRetake}
            setActiveForm={setActiveForm}
            activeForm={activeForm}
            captchaSiteKey={captchaSiteKey}
          />
        )}
      </div>
    </div>
  )
}

export default PopupForInternShips
